import { render, staticRenderFns } from "./ByApp.vue?vue&type=template&id=c3bf147c&scoped=true"
import script from "./ByApp.vue?vue&type=script&lang=js"
export * from "./ByApp.vue?vue&type=script&lang=js"
import style0 from "./ByApp.vue?vue&type=style&index=0&id=c3bf147c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c3bf147c",
  null
  
)

export default component.exports